<template>
  <div>
    <div id="printType" style="display:none">
      <div class="printType">
        <div class="line" v-html="strHtml"></div>
      </div>
    </div>
    <b-modal v-model="clickOpen" hide-header hide-footer no-close-on-backdrop title="In hóa đơn" class="modalDialog">
      <div class="box-modal">
        <div class="heads-modal">
          <span>In hóa đơn</span>
          <button type="button" aria-label="Close" class="close close-ext" @click="$emit('clickOpen', false)">×</button>
        </div>
        <div class="text-des-modal mt-2 text-bold">Chọn thông tin bạn muốn in</div>
        <div class="text-des-modal mt-2"><label><input type="radio" checked> Hóa đơn</label></div>
        <div class="text-des-modal mt-2 text-bold">Chọn mẫu in</div>
        <div class="text-des-modal mt-2">
          <label><input type="radio" name="clickPrintType" @click="clickPrintType = 1" checked> In đầy đủ</label>
        </div>
        <div class="mt-2">
          <div class="btn btn-md btn-white" :class="{ btnAct: isActive == 1 }" @click="clickOpenTypeOne(1)">Mẫu in A4</div>
          <div class="btn btn-md btn-white" :class="{ btnAct: isActive == 2 }" @click="clickOpenTypeOne(2)">Mẫu in A5</div>
          <div class="btn btn-md btn-white" :class="{ btnAct: isActive == 3 }" @click="clickOpenTypeOne(3)">Mẫu in K57</div>
          <div class="btn btn-md btn-white" :class="{ btnAct: isActive == 4 }" @click="clickOpenTypeOne(4)">Mẫu in K80</div>
        </div>
        <div class="mt-3 line-active text-right">
          <div class="btn btn-md btn-primary" @click="print" v-if="loadingOk && isActive > 0">In ngay</div>
          <b-button disabled class="btn btn-md btn-primary" v-if="isActive == 0">In ngay</b-button>
          <b-button disabled class="btn btn-md btn-primary" v-if="!loadingOk && isActive > 0"><i
              class="fas fa-spinner fa-spin"></i> Đang tạo hóa đơn</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import VueCookies from "vue-cookies"
import { SettingPrintsService } from "@/services/nextshop/setting.prints.service"
import { showMessPrints } from "@/utils/pos"

export default {
  name: "orderPrints",
  props: {
    orderData: {
      type: Object,
      default: () => { return {} }
    },
    clickOpen: {
      type: Boolean,
    }
  },
  data() {
    return {
      isActive: 0,
      clickOpenType: 1,
      clickPrintType: 1,
      locationId: VueCookies.get("LID"),
      strHtml: '',
      loadingOk: false
    }
  },

  async created() {

  },

  methods: {
    async clickOpenTypeOne(value) {

      this.loadingOk = false
      this.clickOpenType = value
      this.isActive = value
      let templateSize = "A4"

      if (this.clickOpenType === 1) {
        templateSize = "A4"
      } else if (this.clickOpenType === 2) {
        templateSize = "A5"
      } else if (this.clickOpenType === 3) {
        templateSize = "K57"
      } else if (this.clickOpenType === 4) {
        templateSize = "K80"
      } else {
        templateSize = "A4"
      }

      const paramBill = {
        locationId: this.orderData.locationToCreate,
        orderId: this.orderData.id,
        templateSize: templateSize
      }

      const dataPrints = await SettingPrintsService.getTempBill(paramBill)
      if (dataPrints.success) {
        this.strHtml = dataPrints.data.data
        this.loadingOk = true
      }
    },
    async print() {
      if (this.strHtml.length > 0) {
        const options = {
          name: '_blank',
          specs: ['fullscreen=no', 'titlebar=no', 'scrollbars=yes'],
          styles: [],
          autoClose: true
        }
        await this.$htmlToPaper('printType', options)
      } else {
        showMessPrints(this)
      }
    }
  }
}
</script>
<style scoped>
.btnAct {
  background: #3e69f6 !important;
  border-color: #3e69f6 !important;
  color: #fff
}

.bg-white {
  background: #fff;
  color: #222
}

.bg-white * {
  color: #222 !important
}

.text-des-modal {
  color: #222 !important
}

.heads-modal {
  border-bottom: 1px solid #F1F2F4;
  display: inline-block;
  width: 100%;
  font-size: 18px;
  padding-top: 10px;
  padding-bottom: 5px
}

.heads-modal .close,
.heads-modal span {
  color: #222 !important
}

.modal-content .close {
  opacity: .8
}

.box-modal {
  margin-bottom: 0 !important
}
</style>
